/**
 * Generate a UUID v4 string
 * Provides fallback for environments where crypto.randomUUID is not available (e.g., older Android WebViews)
 */
export function generateUUID(): string {
  // Try native crypto.randomUUID first (best performance & security)
  if (
    typeof crypto !== "undefined" &&
    typeof crypto.randomUUID === "function"
  ) {
    return crypto.randomUUID();
  }

  // Fallback for older browsers/WebViews
  console.log("⚠️ Using UUID fallback (crypto.randomUUID not available)");
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
